import { useContext } from 'react';

import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { useTranslation } from 'react-i18next';

import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import { PageIcons } from 'src/assets/icons';
import { getRole } from 'src/utils/session';



const MenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: ${theme.spacing(1)};

      & > .MuiList-root {
        padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
      }
    }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.palette.text.secondary};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
  `
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      .MuiListItem-root {
        padding: 1px 0;

        .MuiButton-root {
          display: flex;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

             color: #ffffff;
          background-color: ${theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.06)
      : alpha(theme.palette.primary.main, 0.04)
    };

          .MuiButton-startIcon {
            color: ${theme.palette.info.light};
            font-size: ${theme.typography.pxToRem(20)};
            margin-inline-end: ${theme.spacing(1)};
          }

          .MuiButton-endIcon {
            color: ${theme.palette.text.secondary};
            margin-inline-start: auto;
            opacity: 0.8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
    background-color: ${theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.25)
      : alpha(theme.palette.info.main, 0.50)
    };

            color: ${theme.palette.primary.contrastText};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.palette.primary.contrastText};
            }
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiButton-root {
            padding: ${theme.spacing(0.8, 3)};

            &:before {
              content: '';
              background: ${theme.palette.text.primary};
              opacity: 0;
              width: 6px;
              height: 6px;
              border-radius: 20px;
              margin-inline-end: ${theme.spacing(1.8)};
              transform: scale(0);
              transition: ${theme.transitions.create(['opacity', 'transform'])};
            }

            &.active,
            &:hover {
              &:before {
                transform: scale(1);
                opacity: 1;
              }
            }
          }
        }
      }
    }
  `
);


function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);
  const { t } = useTranslation();
  const role = getRole();
  const isAdmin = role?.[0] === "Admin";
  const isAdminStaff = role?.[0] === "AdminStaff";;
  const isLawyer = role?.[0] === "Lawyer";
  const isClient = role?.[0] === "Client"

  return (
    <>
      <MenuWrapper>

        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                startIcon={<PageIcons.Overview />}

                component={RouterLink}
                onClick={closeSidebar}
                to="/dashboards/crypto"

              >
                {(isAdmin || isAdminStaff) ? t("Overview") : t("Home")}
              </Button>
            </ListItem>
          </List>

        
          {
            (isAdmin || isAdminStaff || isLawyer) && (
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/Page/consultations"
                    startIcon={<PageIcons.Consultations />}

                  >
                    {t("Consultations")}
                  </Button>
                </ListItem>
              </List>
            )
          }

          <List>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/Page/cases"
                startIcon={<PageIcons.Cases />}

              >
                {t("Cases")}
              </Button>
            </ListItem>
          </List>
                   {
            (isAdmin || isAdminStaff) && (
              <><List>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/Page/lawyer"
                    startIcon={<PageIcons.Lawyers />}

                  >
                    {t("Lawyers")}

                  </Button>
                </ListItem>
              </List>
              <List>
                  <ListItem component="div">
                    <Button
                      disableRipple
                      component={RouterLink}
                      onClick={closeSidebar}
                      to="/Page/client"
                      startIcon={<PageIcons.Client />}
                    >
                      {t("Client")}
                    </Button>
                  </ListItem>
                </List>

                {role[0] === "Admin" && (
                  <List>

                    <ListItem component="div">
                      <Button
                        disableRipple
                        component={RouterLink}
                        onClick={closeSidebar}
                        to="/Page/admin-staff"
                        startIcon={<PageIcons.AdminStaff />}

                      >
                        {t("Admin Staff")}
                      </Button>
                    </ListItem>

                  </List>
                )}
              <List>
                  <ListItem component="div">
                    <Button
                      disableRipple
                      component={RouterLink}
                      onClick={closeSidebar}
                      to="/Page/banners"
                      startIcon={<PageIcons.Banners />}
                    >
                      {t("Banners")}
                    </Button>
                  </ListItem>
                </List><List>
                  <ListItem component="div">
                    <Button
                      disableRipple
                      component={RouterLink}
                      onClick={closeSidebar}
                      to="/Page/notifications"
                      startIcon={<PageIcons.Notifications />}
                    >
                      {t("Notifications")}
                    </Button>
                  </ListItem>
                </List>

              </>

            )
          }

            {
            (isAdmin || isAdminStaff) && (
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    startIcon={<PageIcons.Specializations />}
                    to="/Page/specializations"
                  >
                    {t("Specializations")}
                  </Button>
                </ListItem>
              </List>
            )}
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/Page/faq"
                startIcon={<PageIcons.FAQ />}

              >
                {t("FAQ")}
              </Button>
            </ListItem>
          </List>
 
        </SubMenuWrapper>
      </MenuWrapper>
    </>
  );
}

export default SidebarMenu;

